import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-9 1.732a8 8 0 0 0 4.001 14.928l-.001 -16a8 8 0 0 0 -4 1.072","key":"svg-0"}]]

const IconContrastFilled = createReactComponent('filled', 'contrast-filled', 'ContrastFilled', __iconNode);

export default IconContrastFilled;